import { contentPaneLabel } from 'owa-locstrings/lib/strings/contentpanelabel.locstring.json';
import loc from 'owa-localize';
import Compose from './Compose';
import Dock from './Dock';
import { observer } from 'mobx-react';
import { createInitialActions, executeInitialActions, InitialActions } from 'owa-initial-actions';
import { ComposeViewState } from 'owa-mail-compose-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import * as React from 'react';

const styles = require('./FullCompose.scss');
const classNames = require('classnames');

export interface FullComposeProps {
    viewState: ComposeViewState;
}

@observer
export default class FullCompose extends React.Component<FullComposeProps, {}> {
    private initialActions: InitialActions;

    constructor(props: FullComposeProps) {
        super(props);
        this.initialActions = createInitialActions();
    }

    componentDidMount() {
        executeInitialActions(this.initialActions);
    }

    render() {
        const viewState = this.props.viewState;
        const scrollContainerClasses = classNames(
            styles.scrollContainer,
            'customScrollBar',
            isFeatureEnabled('tri-dynamicLayout') && styles.noMinWidth
        );
        return (
            <div tabIndex={-1} role={'main'} aria-label={loc(contentPaneLabel)}>
                <Compose
                    viewState={viewState}
                    className={scrollContainerClasses}
                    initialActions={this.initialActions}>
                    <div className={styles.scrollRegionBottomBuffer} />
                </Compose>
                <Dock viewState={viewState} initialActions={this.initialActions} />
            </div>
        );
    }
}
